import { Div, CollectionView, Span } from "@tblabs/truffle";
import { Calendar } from "../../../../../Components/Calendar/Calendar";
import { CalendarEntry } from "../../../../../Components/Calendar/CalendarEntry";
import { Order } from "../../../../../Models/Order";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class ProfitView extends Div
{
    constructor(private orders: CollectionView<Order>)
    {
        super();
        this.TextAlignCenter();

        const incomes = this.orders.Items.flatMap(order => order.Mana(["ReceivedIncome"]));
        // const total = incomes.reduce((acc, income) => acc + income.Amount, 0);
        const total = this.orders.Items.reduce((acc, order) => acc + order.Profit, 0);

        const incomesByDay = incomes.reduce((acc, income) =>
        {
            const dateKey = income.When.toDateString();
            if (!acc[dateKey])
            {
                acc[dateKey] = [];
            }
            acc[dateKey].push(income);
            return acc;
        }, {} as Record<string, typeof incomes>);


        const calendarEntries: CalendarEntry[] = Object.entries(incomesByDay).map(([date, incomes]) =>
            new CalendarEntry(new Date(date), () =>
            {
                let content: appendable[] = [];
                const dayTotal = incomes.reduce((acc, income) => acc + income.Amount, 0);

                if (dayTotal > 0)
                    content.push(new Span("+" + dayTotal + " zł").Class("uk-badge").FontSize(15));
                return content;
            }));

        const calendar = new Calendar(calendarEntries);

        this.Append(
            "Uwaga! To źle liczy! Do poprawki!",
            calendar,
            new Span(total + " zł").Class("uk-badge").FontSize(20)
        );
    }
}




